import React, { useEffect } from "react";
import { connect } from "react-redux";
import Page from "orion/lib/page";
import Loader from "orion/lib/loader";
import { AlertSchemasContext } from "../contexts/alertSchemasContext";
import AlertsSetting from "../components/alertsSetting";
import { fetchAlertSchemas } from "../actionCreators/alertsSettingActionCreators";
import { alertsTypeListSelector } from "../selectors/alertsTypeListSelector";
import { useDruvaAlerts } from "../contexts/DruvaAlertsContext";

var AlertsSettingContainer = function AlertsSettingContainer(props) {
  var isLoading = props.isLoading,
      alertSchemas = props.alertSchemas,
      isModalOpen = props.isModalOpen,
      fetchingAdmins = props.fetchingAdmins,
      adminList = props.adminList,
      fetchAlertSchemas = props.fetchAlertSchemas;

  var _useDruvaAlerts = useDruvaAlerts(),
      _useDruvaAlerts$apiCo = _useDruvaAlerts.apiConfig,
      alertsApiPath = _useDruvaAlerts$apiCo.alertsApiPath,
      accessTokenApiPath = _useDruvaAlerts$apiCo.accessTokenApiPath,
      alertsApiBaseUrl = _useDruvaAlerts$apiCo.alertsApiBaseUrl;

  useEffect(function () {
    fetchAlertSchemas({
      apiBaseUrl: alertsApiBaseUrl,
      apipathprefix: alertsApiPath,
      accessTokenApiPath: accessTokenApiPath
    });
  }, []);
  return /*#__PURE__*/React.createElement(Page.Main, null, /*#__PURE__*/React.createElement(Page.Header, null, /*#__PURE__*/React.createElement(Page.Title, null, /*#__PURE__*/React.createElement(Page.TitleText, null, "Settings"))), /*#__PURE__*/React.createElement(Page.Body, null, /*#__PURE__*/React.createElement(Loader, {
    isLoading: isLoading,
    fullPage: true
  }), /*#__PURE__*/React.createElement(AlertSchemasContext.Provider, {
    value: {
      alertSchemas: alertSchemas,
      isModalOpen: isModalOpen,
      fetchingAdmins: fetchingAdmins,
      adminList: adminList
    }
  }, /*#__PURE__*/React.createElement(AlertsSetting, null))));
};

var mapDispatchToProps = {
  fetchAlertSchemas: fetchAlertSchemas
};

var mapStateToProps = function mapStateToProps(state) {
  return alertsTypeListSelector(state);
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertsSettingContainer);